// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2hJc5","selected":"Chip_selected__3FMBf"};